import axiosInstance from '@/lib/axios';
import { ENDPOINTS } from './endpoints';
import type {
  LoginPayload,
  RegisterPayload,
  ForgotPasswordPayload,
  ResetPasswordPayload,
  AuthResponse,
  AuthUser,
  V2LoginPayload,
  V2LoginResponse,
  UserProfile,
  UserAuthority,
} from '@/types/auth.types';

import type { ApiResponse } from '@/types/common.types';

export const authApi = {
  /** V2 login – direct response (no wrapper) */
  v2Login: (payload: V2LoginPayload) =>
    axiosInstance.post<V2LoginResponse>(ENDPOINTS.AUTH.LOGIN, payload),

  login: (payload: LoginPayload) =>
    axiosInstance.post<ApiResponse<AuthResponse>>(ENDPOINTS.AUTH.LOGIN, payload),

  register: (payload: RegisterPayload) =>
    axiosInstance.post<ApiResponse<AuthResponse>>(ENDPOINTS.AUTH.REGISTER, payload),

  logout: (payload: { access_token: string; refresh_token: string; all: boolean }) =>
    axiosInstance.post<ApiResponse<null>>(ENDPOINTS.AUTH.LOGOUT, payload),

  forgotPassword: (payload: ForgotPasswordPayload) =>
    axiosInstance.post<ApiResponse<null>>(ENDPOINTS.AUTH.FORGOT_PASSWORD, payload),

  resetPassword: (payload: ResetPasswordPayload) =>
    axiosInstance.post<ApiResponse<null>>(ENDPOINTS.AUTH.RESET_PASSWORD, payload),

  getMe: () => axiosInstance.get<ApiResponse<AuthUser>>(ENDPOINTS.AUTH.ME),

  /** GET /v2/users/me — returns full user profile (country, name, etc.) */
  getUserProfile: () =>
    axiosInstance.get<ApiResponse<UserProfile>>(ENDPOINTS.AUTH.ME),

  /** GET /v2/users/authority — returns roles[] and permissions[] */
  getAuthority: () =>
    axiosInstance.get<ApiResponse<UserAuthority>>(ENDPOINTS.AUTH.AUTHORITY),

  refreshToken: (refreshToken: string) =>
    axiosInstance.post<ApiResponse<{ accessToken: string; expiresIn: number }>>(
      ENDPOINTS.AUTH.REFRESH,
      { refreshToken }
    ),
};
